import React, { Component } from 'react';
import './Info.css';
import InfoTile from '../../Tile/InfoTile/InfoTile';
import dataset from '../../../assets/stk_db/stickfig.json';
import { useParams } from 'react-router-dom';

function Info (data){

    const images = require.context('../../../assets/stk_material/Pic/stk_images', true);
    const stk = require.context('../../../assets/stk_material/Stk', true);
    const newname = (cat, name, ext) => "./"+ cat + "/"+ name + "." + ext;
    const {stkId} = useParams();
    
    console.log(stkId)
    return(

      <div className="StickInfoContainer">
            {data.data.map((stickfig, index) => {

                if (stickfig.id ===  stkId) {

                    return(
                    <InfoTile
                        key={stickfig.id}
                        name={stickfig.name}
                        link = {stickfig.link}  
                        creator={stickfig.creator}
                        category= {stickfig.category}
                        detail= {stickfig.detail}
                        pic = {images(newname(stickfig.category,
                            stickfig.name,
                            stickfig.pic
                            ))}
                        version = {stickfig.version}
                        stk = {stk(newname(stickfig.category,
                            stickfig.name,
                            stickfig.file
                            ))}
                        file = {stickfig.file}
                        creatorclick = {() => this.setCreator()}
                        
                    />);
                }
            })}
    </div>

    );
}

export default Info;